@if(backButton){
  <app-button [text]="'<'" [matButtonAparence]="'tonal'" [href]="'/' + backUrl()"></app-button>
  <app-divider></app-divider>
}

<app-titledescription [title]="'Detalle'"></app-titledescription>
@if(templateHeaderDescription){
        <ng-container *ngTemplateOutlet="templateHeaderDescription"></ng-container>
        <div class="divider my-6"></div>
      }
@if(!useCompactVersion){
  <div class="bg-white rounded-lg shadow-md p-6">
    <table class="table-container min-w-full divide-y divide-gray-400 bg-white ">
      <tbody class="divide-y divide-gray-300 ">
        @if(data){
          @for(col of columnNames; track col){
            <tr>
              <td class="px-6 py-4 whitespace-nowrap text-gray-700 font-medium pr-4">
                {{ col.label }}
              </td>
              <td class="px-6 py-4 text-gray-500 break-all max-w-[500px]">
                {{ getValue(data, col.name, col.pipe) }}
              </td>
            </tr>
          }
        }
        @else{
          <div class="spinner-overlay">
            <mat-spinner></mat-spinner>
          </div>
        }
      </tbody>
    </table>
  </div>
}@else {
  <!-- Versión compacta para modal -->
  <div class="bg-white rounded-lg text-base shadow p-2" style="max-width: 600px; margin: 10px auto;">
    <table class="table-container w-full divide-y divide-gray-300 bg-white">
      <tbody class="divide-y divide-gray-300">
        @if(data){
          @for(col of columnNames; track col){
            <tr>
              <td class="px-2 py-2 text-gray-700 font-medium pr-2" style="width: 150px;" [style.border-bottom]="$index === columnNames.length - 1 ? '' : '1px solid #e5e7eb'">
                {{ col.label }}
              </td>
              <td class="px-2 py-2 text-gray-500 break-all" style="max-width: 220px;" [style.border-bottom]="$index === columnNames.length - 1 ? '' : '1px solid #e5e7eb'">
                {{ getValue(data, col.name, col.pipe) }}
              </td>
            </tr>
          }
        }
        @else{
          <div class="spinner-overlay">
            <mat-spinner></mat-spinner>
          </div>
        }
      </tbody>
    </table>
  </div>
}



